import { render, staticRenderFns } from "./header-bubbles.vue?vue&type=template&id=7fd1b9ee&scoped=true&lang=pug&"
import script from "./header-bubbles.vue?vue&type=script&lang=js&"
export * from "./header-bubbles.vue?vue&type=script&lang=js&"
import style0 from "./header-bubbles.vue?vue&type=style&index=0&id=7fd1b9ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd1b9ee",
  null
  
)

export default component.exports